// API URL для подключения к backend
// В продакшн режиме используем пустую строку (относительный путь),
// так как фронтенд и бэкенд работают на одном порту
export const API_URL = process.env.REACT_APP_API_URL || '';

export default API_URL;
